import React, { Children, FC, useEffect, useRef } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

SwiperCore.use([Pagination, Navigation, Autoplay, A11y, Scrollbar]);

export interface SimpleSliderProps {
  children: React.ReactNode;
  slideTo?: number;
  autoHeight?: boolean;
  className?: string;
  isRenderAgain?: boolean;
  isShowPagination?: boolean;
  isShowNavigation?: boolean;
  isAutoPlay?: boolean;
  allowTouchMove?: boolean;
  onSlideChange?: (index: number) => void;
}

const SimpleSlider: FC<SimpleSliderProps> = ({
  children,
  slideTo = 0,
  autoHeight = true,
  className,
  isRenderAgain = false,
  isShowPagination = false,
  isShowNavigation = false,
  isAutoPlay = false,
  allowTouchMove = true,
  onSlideChange,
}) => {
  const swiperRef = useRef<SwiperClass>();

  //const [renderAgain, setRenderAgain] = React.ueState<boolean>(isRenderAgain);

  useEffect(() => {
    //setRenderAgain(!renderAgain);
    swiperRef.current.update();
  }, [isRenderAgain]);

  useEffect(() => {
    if (swiperRef.current && Children.count(children) >= slideTo) {
      swiperRef.current.slideTo(slideTo);
    }
  }, [slideTo]);

  return (
    <Swiper
      className={`simple-slider ${className}`}
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      spaceBetween={50}
      slidesPerView={1}
      noSwiping
      navigation={isShowNavigation}
      pagination={isShowPagination ? { clickable: true } : false}
      allowTouchMove={allowTouchMove}
      autoHeight={autoHeight}
      autoplay={isAutoPlay}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      onSlideChange={(swiper) => {
        onSlideChange?.(swiper.activeIndex);
      }}
    >
      {Children.map(children, (child, index) => (
        <SwiperSlide key={`slide-${index}`}>{child}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SimpleSlider;
